/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class BackgroundJobPayloadForPeriodicWorkloadVulnerabilityThreatSummaryMonthly extends models.PeriodicBackgroundJobPayloadBase {
    constructor() {
        super();
        this.setDiscriminator("BackgroundJobPayloadForPeriodicWorkloadVulnerabilityThreatSummaryMonthly");
    }

    getFixupPrototypeFunction() { return BackgroundJobPayloadForPeriodicWorkloadVulnerabilityThreatSummaryMonthly.fixupPrototype; }

    static newInstance(model: Partial<BackgroundJobPayloadForPeriodicWorkloadVulnerabilityThreatSummaryMonthly>): BackgroundJobPayloadForPeriodicWorkloadVulnerabilityThreatSummaryMonthly {
        let obj = Object.assign(new BackgroundJobPayloadForPeriodicWorkloadVulnerabilityThreatSummaryMonthly(), model);
        BackgroundJobPayloadForPeriodicWorkloadVulnerabilityThreatSummaryMonthly.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<BackgroundJobPayloadForPeriodicWorkloadVulnerabilityThreatSummaryMonthly>): BackgroundJobPayloadForPeriodicWorkloadVulnerabilityThreatSummaryMonthly {
        if (!model) return null;
        return BackgroundJobPayloadForPeriodicWorkloadVulnerabilityThreatSummaryMonthly.newInstance(<BackgroundJobPayloadForPeriodicWorkloadVulnerabilityThreatSummaryMonthly> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: BackgroundJobPayloadForPeriodicWorkloadVulnerabilityThreatSummaryMonthly) {
        if (!obj) return;

        models.BackgroundJobPayloadForPeriodicWorkloadVulnerabilityThreatSummaryMonthly.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: BackgroundJobPayloadForPeriodicWorkloadVulnerabilityThreatSummaryMonthly): boolean {
        if (models.PeriodicBackgroundJobPayloadBase.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, BackgroundJobPayloadForPeriodicWorkloadVulnerabilityThreatSummaryMonthly.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
    }

}
